import PropTypes from "prop-types";
import { Provider } from "react-redux";
import LocaleProvider from "../../components/LocaleProvider";
import { Switch } from "react-router-dom";
import ErrorBoundary from "../ErrorBoundary";
import routes from "../../routes";

const App = ({ store, translations, history, RouterComponent, location }) => {
  const props = CLIENT ? { history } : { location };

  return (
    <Provider store={store}>
      <LocaleProvider translations={translations}>
        <ErrorBoundary>
          <RouterComponent {...props}>
            <Switch>{routes}</Switch>
          </RouterComponent>
        </ErrorBoundary>
      </LocaleProvider>
    </Provider>
  );
};

App.propTypes = {
  store: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  RouterComponent: PropTypes.any.isRequired,
  history: PropTypes.object,
  location: PropTypes.string
};

export default App;
